export const bookTypes = {
    audio: 'Audio-CD',
    audio_file: 'Audiodatei',
    book: 'Buch',
    hardcover: 'Hardcover',
    softcover: 'Softcover',
    spiral_binding: 'Spiralbindung',
    booklet: 'Heft',
    leather_or_luxury_binding: 'Leder-/Kunstleder- oder Prachteinband',
    fascicle: 'Faszikel (Teilwerk)',
    leporello: 'Leporello',
    map: 'Landkarte (gefaltet)',
    cd_rom: 'CD-ROM',
    ebook: 'E-Book',
    ebook_online: 'E-Book - online verfügbar',
    ebook_download: 'E-Book - Download',
    calendar: 'Kalender',
    poster: 'Schautafel',
    bookmark: 'Lesezeichen',
    brochure: 'Broschüre',
    other_print_product: 'Sonstiges Printprodukt (Nonbook)',
    multipart_product: 'Mehrteiliges Produkt',
    dvd: 'DVD',
    vhs: 'VHS',
    floor_display: 'Bodendisplay (leer)',
    counter_display: 'Thekendisplay (leer)',
    advertising_poster: 'Werbeplakat',
    rotating_display: 'Drehsäule (leer)',
    non_book: 'Nonbook',
    carrying_bag: 'Tragetasche',
    other_product: 'Sonstiges Produkt'
};

export const bookStatus = {
    shortage: 'fehlt kurzfristig - Bestellung notiert',
    out_of_stock: 'vergriffen -> Bestellung abgelegt',
    planned: 'in Planung - interne Daten',
    non_web: 'nonweb - interne Daten',
    discontinued: 'erscheint nicht - Titel eingestellt',
    blocked: 'Auslieferung gestoppt - Titel gesperrt',
    available: 'lieferbar',
    reprint: 'Nachdruck ohne Termin - vorgemerkt',
    new_edition: 'vergriffen --> siehe Neuauflage',
    available_without_vlb: 'Lieferbar - ohne VLB-Eintrag',
    pending: 'in Vorbereitung - Bestellung notiert'
}

export const bookFileTypes = {
    cover: 'Cover',
    backcover: 'Backcover',
    product: 'Produktbild',
    author_image: 'Autorenbild',
    promotional_material: 'Werbematerial',
    sample_text: 'Leseprobe',
    table_of_contents: 'Inhaltsverzeichnis',
    index: 'Register',
    introduction: 'Editorial',
    errata: 'Errata',
    other: 'Sonstiges'
};

export const bindingTypes = {
    softcover: 'Fadenbindung',
    'softcover-thread': 'Klebebindung',
    hardcover: 'Pappband',
    pamphlet: 'Klammerheftung',
    wire_comb_binding: 'Drahtkammbindung',
    spiral: 'Spiraldrahtbindung',
    loose_leaf: 'Loseblatt',
    linen: 'Leinen',
    leather: 'Leder',
    artificial_leather: 'Kunstleder',
    leather_fiber: 'Lederfaserstoff',
    headband_ribbons: 'Kapitalbänder',
    linen_without_reinforcement: 'Leinen (ohne Verstärkung)',
    artificial_linen: 'Kunstleinen',
    with_dust_jacket: 'mit Schutzumschlag',
    with_dust_jacket_printed: 'mit Schutzumschlag (bedruckt)',
    with_dust_jacket_transparent: 'mit Schutzumschlag (durchsichtig)',
    with_flaps: 'mit Klappen',
    with_bookmark: 'mit Lesebändchen',
    with_foldout: 'mit Faltblatt',
    epub: 'EPUB',
    pdf: 'PDF',
    ios_app: 'iOS App',
    android_app: 'Android App',
    postcards: 'Postkarten'
}

export const bookEditionTypes = {
    new_edition: "Neuausgabe",
    revised_edition: "Überarbeitete Ausgabe",
    stage_edition: "Bühnenausgabe",
    unabridged_edition: "Ungekürzte Ausgabe",
    adapted_edition: "Bearbeitete Ausgabe",
    alternative_edition: "Alternative Ausgabe",
    simplified_language_edition: "Ausgabe in Einfacher Sprache",
    bilingual_edition: "Zweisprachige Ausgabe",
    braille_edition: "Brailleausgabe",
    digital_original_edition: "Digitale Originalausgabe",
    enhanced_ebook: "Enhanced E-Book",
    enlarged_edition: "Erweiterte Ausgabe",
    facsimile: "Faksimile",
    festschrift: "Festschrift",
    abridged_edition: "Gekürzte Ausgabe",
    large_type_edition: "Großdruck (Schriftgröße 14-19 pt)",
    illustrated_edition: "Illustrierte Ausgabe",
    ultra_large_print_edition: "Großdruck (Schriftgröße > 20 pt)",
    critical_edition: "Kritische Ausgabe",
    course_edition: "Kursausgabe",
    teacher_edition: "Lehrerausgabe",
    media_tie_in: "Buch zum Film, Spiel etc.",
    multilingual_edition: "Mehrsprachige Ausgabe",
    microprint: "Mikroschrift",
    annotated_edition: "Kommentierte Ausgabe",
    numbered_limited_edition: "Limitierte und nummerierte Ausgabe",
    omnibus_edition: "Sammelband",
    student_edition: "Schülerausgabe",
    school_edition: "Schulausgabe",
    special_edition: "Sonderausgabe",
    variorum_edition: "Variorum-Ausgabe",
    pre_bound_edition: "Vorgebundene Ausgabe/Bibliotheksausgabe",
    unexpurgated_edition: "Unzensierte Originalfassung",
    expurgated_edition: "Zensierte Ausgabe",
    paperback_original: "Nur als Paperback",
    anniversary_edition: "Jubiläumsausgabe",
    bilingual_parallel_text: "Zweisprachiger Paralleldruck",
    easy_to_read_edition: "Leicht zu lesende Ausgabe",
    high_readability_edition: "High Readability Ausgabe",
    international_edition: "Internationale Ausgabe",
    signed_edition: "Signierte Ausgabe",
    unnumbered_limited_edition: "Limitierte Ausgabe",
    read_aloud_edition: "Vorlesebücher",
};


export const bookContractTypes = {
    publisher: 'Verlags-/Autorenvertrag',
    license: 'Lizenzvertrag',
    translator: 'Übersetzervertrag',
    editor: 'Herausgebervertrag',
    compound_author: 'Sammelvertrag',
    cooperation: 'Kooperationsvertrag',
    fulfilment: 'Auslieferungsvertrag',
    commision: 'Kommisionsvertrag'
}

export const contributorTypes = {
    main_author: 'Autor / Autorin',
    co_author: 'Zusammen mit',
    licensor: 'Lizenzgeber',
    licensee: 'Lizenznehmer',
    agent: 'Agent',
    artist: 'Künstler / Künstlerin',
    photographer: 'Fotograf / Fotografin',
    illustrator: 'Illustriert von',
    photos_by: 'Fotos von',
    introduction_by: 'Einführung von',
    summary_by: 'Zusammenfassung von',
    afterword_by: 'Nachwort von',
    annotations_by: 'Anmerkungen von',
    commented_by: 'Kommentiert von',
    foreword_by: 'Vorwort von',
    preface_by: 'Einleitung von',
    footnotes_by: 'Fußnoten von',
    memoirs_by: 'Erinnerungen von',
    introduction_and_annotations_by: 'Einleitung und Anmerkungen von',
    text_and_lyrics_by: 'Text und Liedtext von',
    contributions_by: 'Beiträge von',
    drawings_by: 'Zeichnungen von',
    cover_design_by: 'Covergestaltung von',
    maps_by: 'Landkarten von',
    colored_by: 'Koloriert von',
    comic_drawings_by: 'Comic-Zeichnungen von',
    comic_coloring_by: 'Comic-Kolorierung von',
    comic_text_by: 'Comic-Text von',
    author_other: 'Verfasser / Verfasserin (sonstige)',
    editor: 'Herausgeber',
    revised_by: 'Überarbeitet von',
    translator: 'Übersetzt von',
    commented_translation_by: 'Kommentierte Übersetzung von',
    series_edited_by: 'Reihe herausgegeben von',
    edited_and_translated_by: 'Herausgegeben und übersetzt von',
    co_edited_by: 'Mitherausgegeben von',
    scientific_editing: 'Wissenschaftliche Redaktion',
    historical_consulting: 'Historische Beratung',
    first_edition_edited_by: 'Erstausgabe herausgegeben von',
    translation_revised_by: 'Übersetzung überarbeitet von',
    image_descriptions_by: 'Bildbeschreibungen von',
    in_honor_of: 'Zu Ehren von',
    peer_reviewed: 'Peer reviewed',
    posthumously_completed_by: 'Posthum vollendet von',
    in_collaboration_with: 'In Zusammenarbeit mit',
    with_assistance_from: 'Unter Mitarbeit von',
    other_contribution: 'Sonstige Mitwirkung',
    royalty_receiver: 'Honorarempfänger',
}

export const priceTypes = {
    retail: 'Ladenpreis',
    free: 'freier Preis',
    subscription: 'Subskriptionspreis',
    bundle: 'Bundle-Preis',
    special: 'Sonderpreis',
};

export const bookRelationTypes = {
    "06": 'Alternatives Format',
    '11': 'Andere Sprachausgabe',
    '23': 'Ähnliches Produkt',
    '01': 'Enthält',
    '02': 'Bestandteil von',
    '13': 'E-Book basiert auf',
    '08': 'Ergänzung zu',
    '03': 'Ersetzt',
    '05': 'Ersetzt von'
}

export const orderTypes = {
    email: 'E-Mail',
    shop: 'Shop',
    phone: 'Telefon',
    fax: 'Fax',
    post: 'Post',
    ibu: 'IBU',
    zeitfracht: 'Zeitfracht',
    libri: 'Libri',
    brochure: 'Prospekt',
    ad: 'Anzeige',
    review: 'Bewertung',
    amazon: 'Amazon',
    subscription: 'Abonnement',
    other: 'Sonstige',
    point_of_sale: 'Barverkauf',
    consignment_delivery: 'Kommissionslieferung',
    consignment_settlement: 'Kommissionsabrechnung',
    consignment_settlement_without_royalty: 'Kommissionsabrechnung (honorarfrei)',
    fixed_purchase_with_royalty: 'Festabnahme (honorarwirksam)',
    fixed_purchase_without_royalty: 'Festabnahme (honorarfrei)',
    deposit: 'Anzahlung Festabnahmen (OSS-wirksam)',
    deposit_own: 'Anzahlung Druckkostenzuschuss (OSS-befreit)',
    subsidy: 'Druckkostenzuschuss',
}

export const orderStatus = {
    pending: 'Offen',
    processing: 'In Bearbeitung',
    completed: 'Abgeschlossen',
    cancelled: 'Storniert',
    draft: 'Entwurf',
}

export const invoiceStatus = {
    paid: 'Bezahlt',
    partially: 'Teilweise bezahlt',
    unpaid: 'Unbezahlt',
}

export const personTypes = {
    consumer: 'Endkunde',
    retailer: 'Buchhändler',
    wholesaler: 'Barsortiment',
    author: 'Autor',
    publisher: 'Verlag',
    reviewer: 'Rezensent',
    other: 'Sonstige'
}

export const royaltyTypes = {
    retail: 'Netto-Ladenpreis (NLP)',
    revenue: 'Netto-Erlös (NVAP)'
}

export const royaltyIntervals = {
    halfyearly: 'halbjährlich',
    yearly: 'jährlich'
}

export const bookCostsTypes = {
    production: 'Herstellung',
    composition: 'Satz',
    editorial: 'Lektorat',
    graphics: 'Grafik',
    license: 'Lizenzen',
    translation: 'Übersetzung',
    royalty: 'Marketing'
}

export const stockTransactionTypes = {
    inbound: "Buchaktivierung",
    outbound: "Buchentnahme",
    inbound_by_invoice: "Buchaktivierung (Rechnung)",
    outbound_by_invoice: "Buchentnahme (Rechnung)",
    transfer: "Umbuchung",
    transfer_by_invoice: "Umbuchung (Rechnung)",
    delivery: "Lieferung",
    return: "Rückgabe",
}

export const addressTypes = {
    shipping: 'Lieferanschrift',
    billing: 'Rechnungsanschrift',
    private: 'Privatadresse',
    headquarter: 'Firmensitz',
    advertising: 'Werbung',
    business: 'Dienstadresse',
    author: 'Autorenanschrift',
    store: 'Filiale',
    editor: 'Herausgeberanschrift',
    creditor: 'Kreditorenanschrift',
    accounting: 'Buchhaltung'
}

export const shippingMethodTypes = {
    fix: 'Versandpauschale',
    linear: 'Preis pro Kg',
    weight: 'Staffel nach Gewicht'
}